<form [formGroup]="formGroup" class="grid-container margin-top wrapper">
  <div class="grid-x grid-margin-x">
    <div class="cell large-12 medium-12 small-12 text-align-center bold">
      <h3 class="h4">Document Scanning Request @if (requestId) {
        : {{requestId}}
      }</h3>
    </div>
    <div class="cell large-3 bold">
      Date / Time of Request:
    </div>
    <div class="cell large-3">
      {{ currentRequest?.timeOfRequest | date: 'MMMM d, y, h:mm a'}}
    </div>
    <div class="cell large-3 bold text-align-right">
      Date DOGRM Received Document:
    </div>
    <div class="cell large-3">
      {{ currentRequest?.dateDocumentReceived | date: 'MM/dd/yyyy'}} @if (originalRequest != null && currentRequest != null) {
      <delta-bubble [expectedDataType]="'Date'" [currentValue]="currentRequest.dateDocumentReceived" [originalValue]="originalRequest.dateDocumentReceived"></delta-bubble>
    }
  </div>
  <div class="cell large-3 bold">
    Group Making the Request:
  </div>
  <div class="cell large-3 padding-right align-self-start">
    @if (currentRequest != null && departments != null) {
      {{ groupRequesting }}@if (originalRequest != null && currentRequest != null) {
      <delta-bubble [domain]="departments" [domainIdProperty]="'id'" [domainDisplayProperty]="'displayName'" [expectedDataType]="'Domain'" [originalValue]="originalRequest.groupRequesting" [currentValue]="currentRequest.groupRequesting"></delta-bubble>
    }
  }
  <text-loader [run]="departments == null" [text]="'Loading Groups'" [tickType]="'.'" [interval]="2000"></text-loader>
</div>
<div class="cell large-3 bold text-align-right">
  Requestor:
</div>
<div class="cell large-3 align-self-start">
  @if (currentRequest != null && groups != null) {
    {{ requestor }}@if (originalRequest != null && currentRequest != null) {
    <delta-bubble [domain]="groups" [domainIdProperty]="'id'" [domainDisplayProperty]="'displayName'" [expectedDataType]="'Domain'" [originalValue]="originalRequest.requestor" [currentValue]="currentRequest.requestor"></delta-bubble>
  }
}
<text-loader [run]="groups == null" [text]="'Loading Groups'" [tickType]="'.'" [interval]="2000"></text-loader>
</div>
<div class="cell large-12 bold padding-bottom">
  Document Details <span class="italic padding-left-large">Each document needs to be scanned individually.</span>
</div>
<div class="cell large-12">
  <div class="grid-container border-one-pixel-solid-gray">
    <div class="grid-x padding-all">
      <div class="cell large-3 bold">
        Document Group:
      </div>
      <div class="cell large-9 align-self-start">
        <ng-container>
          {{ currentRequest?.documentGroup }}
          @if (originalRequest != null && currentRequest != null) {
            <delta-bubble [expectedDataType]="'string'" [originalValue]="originalRequest.documentGroup" [currentValue]="currentRequest.documentGroup"></delta-bubble>
          }
        </ng-container>

      </div>
      <div class="cell large-3 bold">
        Type / Name of Document:
      </div>
      <div class="cell large-9 align-self-start">
        <ng-container>
          {{ currentRequest?.documentType }}
          @if (originalRequest != null && currentRequest != null) {
            <delta-bubble [expectedDataType]="'string'" [originalValue]="originalRequest.documentType" [currentValue]="currentRequest.documentType"></delta-bubble>
          }
        </ng-container>
      </div>
      <div class="cell large-12 bold">
        Look up Values:
      </div>
      <div class="cell large-12 bold">
        Minimum Selection: 1 Lookup Field
      </div>
      <div class="cell large-2 bold padding-left-large text-align-right padding-right-small">
        API Number:
      </div>
      <div class="cell large-4">
        {{ currentRequest?.apiNumber }}
        @if (originalRequest != null && currentRequest != null) {
          <delta-bubble [expectedDataType]="'String'" [originalValue]="originalRequest.apiNumber" [currentValue]="currentRequest.apiNumber"></delta-bubble>
        }
      </div>
      <div class="cell large-2 bold padding-left text-align-right padding-right-small">
        Application Number:
      </div>
      <div class="cell large-4">
        {{ currentRequest?.applicationNumber }}
        @if (originalRequest != null && currentRequest != null) {
          <delta-bubble [expectedDataType]="'String'" [originalValue]="originalRequest.applicationNumber" [currentValue]="currentRequest.applicationNumber"></delta-bubble>
        }
      </div>
      <div class="cell large-2 bold text-align-right padding-right-small">
        RICS Owner Number:
      </div>
      <div class="cell large-4">
        {{ currentRequest?.organization }}
        @if (originalRequest != null && currentRequest != null) {
          <delta-bubble [expectedDataType]="'String'" [originalValue]="originalRequest.organization" [currentValue]="currentRequest.organization"></delta-bubble>
        }
      </div>
      <div class="cell large-2 bold padding-left">
        RBDMS Owner Number:
      </div>
      <div class="cell large-4">
        {{ currentRequest?.rbdmsNumber }}
        @if (originalRequest != null && currentRequest != null) {
          <delta-bubble [expectedDataType]="'String'" [originalValue]="originalRequest.rbdmsNumber" [currentValue]="currentRequest.rbdmsNumber"></delta-bubble>
        }
      </div>
      <div class="cell large-2">
        <div class="checkbox">
          <input id="legal" type="checkbox" formControlName="legalReview" class="show-for-sr" />
          <label for="legal">
            <span class="checkbox-box" aria-hidden="true">
              <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
            </span>
            Legal Review Required
          </label>
        </div>
      </div>
      <div class="cell large-10">
        @if (originalRequest != null && currentRequest != null) {
          <delta-bubble [expectedDataType]="'Boolean'" [originalValue]="originalRequest.legalReviewRequired" [currentValue]="currentRequest.legalReviewRequired"></delta-bubble>
        }
      </div>
      <div class="cell large-2">
        <div class="checkbox">
          <input id="confidential" type="checkbox" formControlName="confidential" class="show-for-sr" />
          <label for="confidential">
            <span class="checkbox-box" aria-hidden="true">
              <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
            </span>
            Private &amp; Confidential
          </label>
        </div>
      </div>
      <div class="cell large-10">
        @if (originalRequest != null && currentRequest != null) {
          <delta-bubble [expectedDataType]="'Boolean'" [originalValue]="originalRequest.confidential" [currentValue]="currentRequest.confidential"></delta-bubble>
        }
      </div>
      <div class="cell large-4 bold">
        Number of Pages (Including Coversheet):
      </div>
      <div class="cell large-1 text-align-left">
        {{ currentRequest?.pages }}
      </div>
      <div class="cell large-7 text-align-left">@if (originalRequest != null && currentRequest != null) {
        <delta-bubble [expectedDataType]="'Number'" [originalValue]="originalRequest.pages" [currentValue]="currentRequest.pages"></delta-bubble>
      }</div>
    </div>
  </div>
</div>
<div class="cell large-12">
  @if (files?.length > 0) {
    <h3 class="minor-margin-bottom h6">Uploaded Files</h3>
    @for (file of files; track file) {
      <div class="flex">
        <uploaded-file [allowFileDeletion]="false" [file]="file"></uploaded-file>
      </div>
    }
  }
</div>
<div class="cell large-12 bold">
  Notes / Instructions: @if (originalRequest != null && currentRequest != null) {
  <delta-bubble [expectedDataType]="'String'" [originalValue]="originalRequest.instructions" [currentValue]="currentRequest.instructions"></delta-bubble>
}
</div>
<div class="cell large-12">
  {{ currentRequest?.instructions }}
</div>
<div class="cell large-12 bold">
  Comments from Scanning:
</div>
<div class="cell large-12">
  {{ currentRequest?.scanningComments }}@if (currentRequest && (currentRequest.scanningComments == null || currentRequest.scanningComments === '')) {
  <span class="red bold">No comments from Scanning.</span>
}
</div>
<div class="cell large-12 bold">
  Comments from Legal:
</div>
<div class="cell large-12">
  {{ currentRequest?.legalComments }}@if (currentRequest && (currentRequest.legalComments == null || currentRequest.legalComments === '')) {
  <span class="red bold">Not submitted to Legal or no comments from Legal.</span>
}
</div>
@if (currentStep !== steps.Loading) {
  <div class="cell large-12 text-align-center">
    <span class="padding-right">
      <button class="button" [disabled]="!enableButtons || isRejecting" (click)="documentGroupConfirm()">Accept</button>
    </span>
    <span class="padding-left">
      <button class="button" [disabled]="!enableButtons" (click)="toggleReject()">@if (isRejecting) {
        <span>Cancel </span>
      }Reject</button>
    </span>
  </div>
}
@if (isRejecting) {
  <div class="cell large-12 bold" [ngClass]="{ 'red' : formGroup?.get('rejectReason')?.invalid }">
    Reason for Rejecting:*
  </div>
  <div class="cell large-12">
    <textarea formControlName="rejectReason"></textarea>
  </div>
  <div class="cell large-12 text-align-center">
    <button class="button" [disabled]="formGroup?.invalid" (click)="rejectScan()">Reject</button>
  </div>
}
</div>
</form>
<a style="display: none;" href="" target="_blank" #downloadLink></a>